import json from "/src/siteData.json"
const constructs = json.pageConstruct

export const getPathFromTemplateType = templateType => {
  const construct = constructs.find(item => item.type === templateType)
  if (!construct) return "/"
  if (templateType === 4) {
    return `/${construct.slug}/p/1`
  }
  return `/${construct.slug}`
}
